import { featureCollection } from "@turf/helpers";

export class DataCollectorUtils {


   static paginateArray<T>(array: T[], pageSize: number): T[][] {
      if (pageSize <= 0) throw new Error("Page size must be greater than 0");

      const pages: T[][] = [];
      for (let i = 0; i < array.length; i += pageSize) {
         pages.push(array.slice(i, i + pageSize));
      }
      return pages;
   }

   /**
    * Helper for WFS concurrent pagination. Will call the provided callback for each page of data, with an optional concurrency limit.
    */
   static async paginateWFS<T, X>(array: T[], pageSize: number, fn: (page: T[], idx: number) => Promise<{ features: X[] }>, concurrent: number = 1): Promise<SFC<X>> {
      if (pageSize <= 0) throw new Error("Page size must be greater than 0");

      let pages = DataCollectorUtils.paginateArray(array, pageSize);
      let idx = 0;
      let workers = await Promise.all(Array.from({ length: concurrent }, async () => {
         let res: X[] = []
         while (pages.length > 0) {
            idx += 1;
            const page = pages.shift();
            let x = await fn(page!, idx)
            if (x.features) {
               res = [...res, ...x.features];
            }
         }
         return res;
      }));

      return featureCollection(workers.reduce((acc, val) => [...acc, ...val], []).flat() as any[]) as any;
   }
}

type SFC<X> = {
   features: X[]
}